import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const employeeContractLocaleModule: LocaleModule = {
  name: "employeeContract",
  messages: { en: en, it: it },
};
